import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function () {
    const aboutUsCertSections = document.querySelectorAll('.js-section-benefits-gif-block');

    aboutUsCertSections.forEach((section) => {
        let swiperInstance = null;

        function initSwiper() {
            const windowWidth = window.innerWidth;

            if (windowWidth >= 1000 && !swiperInstance) {
                swiperInstance = new Swiper('.js-swiper-benefits-gif', {
                    modules: [Pagination],
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 60,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                });
            } else if (windowWidth < 1000 && swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        }

        // Initialize Swiper on load and resize
        initSwiper();
        window.addEventListener('resize', initSwiper);
    });
});
